import { ReactNode } from 'react';
import { Box } from '@cad-arc';

export function ExpandableContent({
    isExpanded,
    children,
}: {
    isExpanded: boolean;
    children: ReactNode;
}) {
    return (
        <Box visibility={isExpanded ? undefined : 'hidden'} height={isExpanded ? undefined : 0}>
            {children}
        </Box>
    );
}
